import { RouterModule, Routes } from "@angular/router";
import { PagesComponent } from './pages.component';
import { HomeComponent } from './home/home.component';
import { DetailsComponent } from "./details/details.component";
import { AboutComponent } from "./about/about.component";
import { LineComponent } from "./line/line.component";
import { ContactComponent } from "./contact/contact.component";

const pagesRoutes: Routes = [
  { 
    path: '', 
    component: PagesComponent,
    children: [
      { path: 'inicio', component: HomeComponent },
      { path: 'curso', component: DetailsComponent },
      { path: 'sobre-mi', component: AboutComponent },
      { path: 'aprendizaje', component: LineComponent },
      { path: 'contacto', component: ContactComponent },
      { path: '**', redirectTo: 'inicio', pathMatch: 'full' },
      { path: '', redirectTo: 'inicio', pathMatch: 'full' }
    ]
  },
]

export const PAGES_ROUTES = RouterModule.forChild( pagesRoutes );